import React from "react";

import Container from "@mui/material/Container"; 

import CadastroAdmin from "../components/Admin/CadastroAdmin";
import ListarUsuarios from "../components/Admin/ListarUsuarios";

function Admin() {
 
	return (
		<Container>
			<h1 className="m-5">Perfil do Administrador</h1>
			
			<CadastroAdmin />
			<ListarUsuarios />
			
		</Container>
	);
}

export default Admin;
